// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Activities_wrapper__13MQj","info":"Activities_info__1k3pe"};